import { Button, ButtonProps } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface IButtonProps extends ButtonProps {
  label?: string;
  isVisible?: boolean;
  icon?: ReactNode;
}

export const XsButton = (props: IButtonProps) => {
  const { label, isVisible = true, icon, ...rest } = props;
  const { t } = useTranslation();
  return (
    <>
      {isVisible ? (
        <Button
          fullWidth
          variant='contained'
          color='primary'
          startIcon={icon}
          {...rest}
          sx={label ? {} : { minWidth: 0, '& .MuiButton-startIcon': { margin: 0 } }}
        >
          {label ? t(label) : ''}
        </Button>
      ) : null}
    </>
  );
};
